import React from "react";
import { useNavigate } from "react-router-dom";
import "./vrviewer.css";
import Btn from "../common/btn";

const VRViewer = () => {
  const navigate = useNavigate();

  return (
    <div className="vr-container">
      
      <div className="back-btn">
        <Btn btn="Back" onClick={() => navigate("/Villas")} />
      </div>

      <iframe
        className="vr-frame"
        title="Villa Virtual Tour"
        src="https://my.matterport.com/show?play=1&lang=en-US&m=d7Kai9ZKt4D"
        allowFullScreen
      ></iframe>

    </div>
  );
};

export default VRViewer;